import React, { useState } from "react";
import { TextField, Button, MenuItem } from "@mui/material";
import { showSuccessToast, showErrorToast } from "../../utils/toaster";
import axios from "axios";
import { baseurl } from "../../config/url";

const OtherPaymentOptions = ({ productId, onClose }) => {
  const [paymentMethod, setPaymentMethod] = useState("NEFT");
  const [paymentDetails, setPaymentDetails] = useState({
    bankName: "",
    accountHolderName: "",
    ifscCode: "",
    transactionId: "",
    amount: "",
    date: "",
  });

  const handleInputChange = (field, value) => {
    setPaymentDetails((prevDetails) => ({
      ...prevDetails,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    const { bankName, accountHolderName, ifscCode, transactionId, amount, date } = paymentDetails;

    if (!bankName || !accountHolderName || !ifscCode || !transactionId || !amount || !date) {
      showErrorToast("Please fill in all required fields.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const sellerId = localStorage.getItem("sellerId");

      const response = await axios.post(
        `${baseurl}/api/payment/other-payment`,
        {
          productId, // Array of product IDs
          paymentMethod,
          paymentDetails: {
            bankName,
            accountHolderName,
            ifscCode,
            transactionId,
            amount,
            date,
          },
          sellerId,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        showSuccessToast("Payment details submitted successfully!");
        onClose(); // Close the modal or navigate back
      }
    } catch (error) {
      showErrorToast("Failed to submit payment details. Please try again.");
    }
  };


  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Other Payment Options</h2>

      {/* Payment Method Selection */}
      <TextField
        select
        label="Select Payment Method"
        value={paymentMethod}
        onChange={(e) => setPaymentMethod(e.target.value)}
        fullWidth
        margin="normal"
      >
        <MenuItem value="NEFT">NEFT</MenuItem>
        <MenuItem value="RTGS">RTGS</MenuItem>
        <MenuItem value="IMPS">IMPS</MenuItem>
        <MenuItem value="DD">Demand Draft (DD)</MenuItem>
        <MenuItem value="Cheque">Cheque</MenuItem>
      </TextField>

      <TextField
        label="Amount"
        value={paymentDetails.amount}
        onChange={(e) => handleInputChange("amount", e.target.value)}
        fullWidth
        margin="normal"
        type="number"
      />
      <TextField
        label="Payment Date"
        value={paymentDetails.date}
        onChange={(e) => handleInputChange("date", e.target.value)}
        fullWidth
        margin="normal"
        type="date"
        InputLabelProps={{
          shrink: true,
        }}
      />

      {/* Bank Details */}
      <TextField
        label="Bank Name"
        value={paymentDetails.bankName}
        onChange={(e) => handleInputChange("bankName", e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Account Holder Name"
        value={paymentDetails.accountHolderName}
        onChange={(e) => handleInputChange("accountHolderName", e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="IFSC Code"
        value={paymentDetails.ifscCode}
        onChange={(e) => handleInputChange("ifscCode", e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Transaction ID"
        value={paymentDetails.transactionId}
        onChange={(e) => handleInputChange("transactionId", e.target.value)}
        fullWidth
        margin="normal"
      />

      {/* Submit Button */}
      <div className="mt-4 flex justify-end">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          className="mr-4"
        >
          Submit
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default OtherPaymentOptions;
